module.exports = __webpack_public_path__ + "img/8_54.34bb7901.png";